import React from 'react';
import { useState } from 'react';

export default function Hamburger({stanMenu, callback, czyCzarne}) {

    return (

        <div id='hamburger' className='relative flex flex-col items-center justify-center w-12 h-12'>
            <button className='absolute top-0 right-0 flex flex-col items-center 
        justify-center w-12 h-12 p-2 space-y-4 z-50' onClick={callback}>

                <span
                    className={`block w-[50px] h-[2px] rounded-full ${czyCzarne ? 'bg-black' : 'bg-white'} transition-all duration-500 transform-gpu ${stanMenu ? "-rotate-45 translate-y-2" : "translate-x-0"
                        }`}
                ></span>

                <span
                    className={`block w-[50px] h-[2px] rounded-full ${czyCzarne ? 'bg-black' : 'bg-white'} transition-all duration-500 transform-gpu ${stanMenu ? "rotate-45 -translate-y-2" : "translate-x-0"
                        }`}
                ></span>
            </button>
        </div>

    )

}